module.exports = __webpack_public_path__ + "static/img/rest21.1de76ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rest21.jpg
// module id = INSc
// module chunks = 0